import { useContext, useEffect, useState } from 'react';
import { useHistory  } from 'react-router-dom'
import { message, Spin } from 'antd';
import WebLinks from '../../../api/WebLinks';
import { CommonContext } from '../../../Context';
import APIUtils from '../../../api/APIUtils';

const EmailverifyRedirect = () => {
  const history = useHistory();
  const commonContext = useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const [isVerifying, setIsVerifying] = useState(true);
  const [jobsUploadHistoryData, setJobsUploadHistoryData] = useState([]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailType = params.get('EmailType') || params.get('emailType') || '';
    const logId = params.get('HILiteEmailLogId') || params.get('hILiteEmailLogId') || '';
    verifyRedirect(emailType, logId);
  }, []);

  const verifyRedirect = async (emailType, logId) => {
    setIsVerifying(true);
    const redirectUrl = `${window.location.origin}/welcome`;
    let payload = null;
    payload = {
      guId:logId,
      sourceUrl: window.location.href,
      redirectUrl: redirectUrl,
    };
    try {
      const response = await APIUtils.apiCall(
        'PUT',
        `${WebLinks.VerifyEmailRedirect}`
        ,JSON.stringify(payload)
      );
      if (!response.isCatch && response.resultObj.statusCode==="2000") {
        history.replace('/welcome',{ verificationStatus: 't' });
      }else {
        message?.error('Email verification failed. Please try again.');
      }
      setIsVerifying(false);
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      {isVerifying ? (
        <div className="text-center">
          <Spin size="large" />
          <div className="mt-3 text-base font-semibold">Verifying.....</div>
        </div>
      ) : null}
    </div>
  );
};

export default EmailverifyRedirect;